import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Recruit() {
  const sectionAnimation = useScrollAnimation();

  const handleNavigate = () => {
    window.REACT_APP_NAVIGATE('/recruit');
  };

  return (
    <section id="recruit" className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          ref={sectionAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`flex flex-col md:flex-row items-center justify-center gap-12 sm:gap-16 md:gap-20 scroll-animate ${sectionAnimation.isVisible ? 'is-visible' : ''}`}
        >
          {/* テキスト情報 - モバイルでは上部、デスクトップでは右側 */}
          <div className="max-w-2xl space-y-5 sm:space-y-7 order-1 md:order-2">
            <div>
              <div className="w-20 sm:w-24 h-0.5 bg-blue-600 mb-3 sm:mb-4"></div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">採用情報</h2>
            </div>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
              採用に関する情報をご覧いただけます。<br />
              経験者の方はもちろん、未経験の方も大歓迎です。
            </p>
            <div className="flex justify-end">
              <a
                href="/recruit"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigate();
                }}
                className="group inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-2.5 sm:py-3 border-2 border-blue-600 text-blue-600 rounded-full hover:bg-blue-600 hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap text-sm sm:text-base"
              >
                <span className="font-semibold">詳しくはこちら</span>
                <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
              </a>
            </div>
          </div>
          
          {/* 画像 - モバイルでは下部、デスクトップでは左側 */}
          <div className="w-64 h-64 sm:w-80 sm:h-80 flex-shrink-0 relative group order-2 md:order-1">
            <div className="absolute inset-0 bg-gradient-to-br from-sky-100 via-sky-200 to-blue-300 rounded-2xl transform rotate-6 group-hover:rotate-12 transition-transform duration-300"></div>
            <div className="relative w-full h-full border-4 border-white rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/0947c5c75234eb0df91750a621813a72/03cb57119928395b45fef342b7ebfcaf.jpeg"
                alt="採用情報"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
